module.exports = __webpack_public_path__ + "media/images/credit_cards/American_Express-1966f8c1d3036962221dac0249e56731.png";